<template>
  <dara-row>
    <dara-col
      :sm="24"
      :md="6">
      <dara-article-link :id="article.id" :slug="article.slug" :track="track">
        <dara-image
          fit="cover"
          :src="image"
          :height="135"
          class="p--lg" />
      </dara-article-link>
    </dara-col>
    <dara-col
      :sm="24"
      :md="18">
      <div class="mb--sm">
        <dara-small>
          {{ createdAt }} {{ $t('by') }}
          <dara-user-link :id="article.user.id" target="_blank">
            {{ article.user.name }} {{ article.user.last_name }}
          </dara-user-link>
          •
        </dara-small>
        <dara-small class="color--success">{{ readingTime }}</dara-small>
      </div>
      <dara-header v-truncate size="sm">
        <dara-article-link :id="article.id" :slug="article.slug" :track="track">{{ article.title }}</dara-article-link>
      </dara-header>
      <dara-p
        v-truncate="2"
        color="regular">
        {{ article.resume }}
      </dara-p>
      <div>
        <dara-small>{{ departmentName }}</dara-small>
        <dara-article-tags :tags="tags" />
      </div>
    </dara-col>
  </dara-row>
</template>

<script>
import { formatToTimeAgo } from '@/helpers/date/date';
import { getArticleImageCover } from '@/modules/article/article.service';
import { getDepartmentById } from '@/modules/department/department.service';
import { translate } from '@/services/translate.service';

import DaraArticleLink from '@/modules/article/components/ArticleLink.vue';
import DaraArticleTags from '@/modules/article/components/ArticleTags.vue';
import DaraUserLink from '@/modules/user/components/UserLink.vue';

export default {
  name: 'ArticleCard',
  components: {
    DaraArticleLink,
    DaraArticleTags,
    DaraUserLink,
  },
  props: {
    article: {
      type: Object,
      required: true,
    },
    track: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      departmentName: null,
    };
  },
  computed: {
    image() {
      return getArticleImageCover(this.article);
    },
    createdAt() {
      return `${formatToTimeAgo(this.article.created_at)}`;
    },
    readingTime() {
      return `${this.article.reading_time} ${translate('min-read')}`;
    },
    tags() {
      return this.article.tags;
    },
  },
  mounted() {
    this.getDepartmentName();
  },
  methods: {
    getDepartmentName() {
      getDepartmentById(this.article.department_id)
        .then(data => {
          this.departmentName = `${translate('in')} ${data.name} `;
        }).catch();
    },
  },
};
</script>
